export function initExpositions() {
//   const container = document.getElementById("expo-text");
//   if (!container) return;

//   const elements = Array.from(container.children);

//   let slides = [];
//   let currentCategory = "";
//   let currentSlide = null;

//   // Parse markdown HTML into slides
//   elements.forEach(el => {
//     if (el.tagName === "H2") {
//       currentCategory = el.innerText;
//     }

//     if (el.tagName === "H3") {
//       currentSlide = {
//         category: currentCategory,
//         title: el.innerText,
//         content: []
//       };
//       slides.push(currentSlide);
//     } else if (currentSlide && el.tagName === "P") {
//       currentSlide.content.push(el.outerHTML);
//     }
//   });

//   // Replace content with slides
//   container.innerHTML = "";

//   slides.forEach((slide, i) => {
//     const div = document.createElement("div");

//     div.className = `expo-slide absolute inset-0 transition-all duration-700 ${
//       i === 0 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
//     }`;

//     div.innerHTML = `
//       <p class="text-sm uppercase text-gray-500">${slide.category}</p>
//       <h2 class="text-2xl font-bold mt-2">${slide.title}</h2>
//       <div class="mt-4">${slide.content.join("")}</div>
//     `;

//     container.appendChild(div);
//   });

//   const textSlides = container.querySelectorAll(".expo-slide");
//   const imageSlides = document.querySelectorAll(".img-slide");

//   let index = 0;

//   function showSlide(i) {
//     // TEXT
//     textSlides.forEach((s, idx) => {
//       s.classList.toggle("opacity-100", idx === i);
//       s.classList.toggle("opacity-0", idx !== i);
//       s.classList.toggle("translate-y-0", idx === i);
//       s.classList.toggle("translate-y-4", idx !== i);
//     });

//     // IMAGES (sync!)
//     imageSlides.forEach((img, idx) => {
//       img.classList.toggle("opacity-100", idx === (i % imageSlides.length));
//       img.classList.toggle("opacity-0", idx !== (i % imageSlides.length));
//     });
//   }

//   showSlide(0);

//   setInterval(() => {
//     index = (index + 1) % textSlides.length;
//     showSlide(index);
//   }, 4000);
  const slides = document.querySelectorAll(".expo-slide")

  if (!slides.length) return

  let current = 0

  setInterval(() => {
    slides[current].classList.remove("opacity-100")
    slides[current].classList.add("opacity-0")

    current = (current + 1) % slides.length

    slides[current].classList.remove("opacity-0")
    slides[current].classList.add("opacity-100")
  }, 4000)
}